import React, { Component } from "react";
import Select from "react-select";
import { TextareaAutosize } from "@material-ui/core";
import Swal from "sweetalert2";

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

const styles = {
  root: {
    color: "#2CBDD7",
  },
};

const hiddenFileInput = React.createRef(null);
const hiddenFileInput_r = React.createRef(null);

class ModalPrecertificado extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <legend>Precertificado</legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="row">
                    {/**FACTURA
                    <div className="form-group col-lg-12">
                    <label htmlFor="establecimiento_precertificado">
                      Factura: <span className="text-danger"> *</span>
                    </label>
                    <select
                        name="mo_factura"
                        className="form-control m-b-5"
                        value={this.props.state.rel_precertificado_solicitud_id}
                        onChange={(e) =>
                          this.props.component.handleChangeNoFactura(e) 
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.facturas.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.num_factura}
                          </option>
                        ))}
                      </select>
                    </div> */}
                    {/* Establecimiento */}
                    <div className="form-group col-lg-12">
                      <label htmlFor="establecimiento_precertificado">
                        Establecimiento: <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="tipo_producto"
                        className="form-control m-b-5"
                        value={this.props.state.establecimiento.id}
                        onChange={(e) =>
                          this.props.component.handleChangeEstablecimiento(e)
                        }
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.options_establecimientos.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.razon_social}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    {/* Tipo producto */}
                  </div>

                  <div
                    className={
                      this.props.state.show_seccion_exportador ? "row" : "hide"
                    }
                  >
                    {/* 
                   <div classList="alert alert-warning">
                    <strong>Warning!</strong> This alert box could indicate a warning that might need attention.
                  </div> */}

                    <div className="row form-group col-lg-12">
                      <div className=" widget widget-stats bg-gradient-yellow m-b-1">
                        <div className="stats-content">
                          <div
                            className="stats-desc"
                            style={{ color: "black" }}
                          >
                            <strong>¡Cuidado!</strong> El establecimiento
                            seleccionado no tiene actividad de exportador. Si desea,
                            puede ingresar un establecimiento exportador o dar click 
                            en el botón azul para continuar:
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group col-md-6">
                      <label>Razón social</label>

                      <input
                        type="text"
                        name="razon_social"
                        id="razon_social_e"
                        onChange={this.props.component.handleEstablecimiento}
                        //value={this.props.state.establecimiento_exportador.razon_social}
                        value={this.props.state.establecimiento.razon_social}
                        className="form-control"
                        disabled={
                          this.props.state.disableEstablecimientoExportador
                        }
                        //placeholder="Ingrese razón social "
                        required
                      />
                    </div>

                    <div className="form-group col-md-5">
                      <label>GUID</label>

                      <input
                        type="text"
                        name="guid"
                        id="guid_e"
                        onChange={this.props.component.handleEstablecimiento}
                        //value={this.props.state.establecimiento_exportador.guid}
                        value={this.props.state.establecimiento.guid}
                        className="form-control"
                        maxLength="4"
                        placeholder="Ingrese GUID "
                        disabled={
                          this.props.state.disableEstablecimientoExportador
                        }
                        required
                      />
                    </div>

                    <div className="col-md-1">
                      <br />
                      <div
                        id="addEst"
                        onClick={this.props.component.handleGuidEstablecimiento}
                        className=" btn btn-light"
                      >
                        <i className="fa fa-th"></i>
                      </div>
                    </div>

                    <br />

                    <div className="row form-group col-lg-12">
                      {/* FABRICANTE (input razon social y guid si mi establecimiento no es fabricante)->(si no, solo traer la info de fabricante, direccion,pais de origen, representantes legales) */}

                      <label htmlFor="nombre_producto">
                        Exportador externo:{" "}
                        <span className="text-danger"> *</span>
                      </label>

                      <input
                        type="input"
                        className="form-control"
                        //placeholder="Causa de la sanción"
                        value={
                          this.props.state.establecimiento_exportador
                            .razon_social
                        }
                        /* onChange={(e) =>
                        this.props.component.handleChangeCEE(e)
                      } */
                        disabled={true}
                      />
                    </div>

                    <div className="row form-group col-lg-12">
                      <button
                        type="button"
                        onClick={() => {
                          this.props.component.handleEstablecimientoNoExtranjero();
                        }}
                        className="btn btn-success  bg-gradient-blue col-lg-12"
                      >
                        No deseo agregar un establecimiento exportador externo
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    {/* Establecimiento */}
                    <div className="form-group col-lg-12">
                      <label htmlFor="establecimiento_precertificado">
                        Tipo de producto:{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="tipo_producto"
                        className="form-control m-b-5"
                        value={this.props.state.tipo_producto_id}
                        onChange={(e) =>
                          this.props.component.handleChangeTipoProducto(e)
                        }
                        disabled={this.props.state.disableTipoProd}
                      >
                        <option value="" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.props.state.options_tipo_producto.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>
                  <div
                    className={
                      this.props.state.show_info_precertificado ? "" : "hide"
                    }
                  >
                    {/* PRODUCTOS REGISTRADOS */}

                    <fieldset
                      className="col-md-12"
                      style={{ backgroundColor: "#6F6F6F" }}
                    >
                      <legend style={{ backgroundColor: "#6F6F6F" }}>
                        Productos registrados
                      </legend>

                      <div className="row">
                        <div
                          className={
                            this.props.state.actividades.length > 1
                              ? "form-group col-lg-5"
                              : "form-group col-lg-6"
                          }
                        >
                          <label htmlFor="establecimiento_precertificado">
                            Productos: <span className="text-danger"> *</span>
                          </label>
                          <select
                            name="producto_id"
                            className="form-control m-b-5"
                            value={
                              this.props.state.producto_registrado.producto_id
                            }
                            onChange={(e) =>
                              this.props.component.handleChangeProductoRegistrado(
                                e
                              )
                            }
                          >
                            <option value="" className="dropdown-item">
                              Seleccione...
                            </option>
                            {this.props.state.options_productos.map(
                              (option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.nombre_comercial}
                                </option>
                              )
                            )}
                          </select>
                        </div>

                        <div className={
                            this.props.state.actividades.length > 1
                              ? "form-group col-lg-2"
                              : "form-group col-lg-3"
                          }>
                          <div className="form-group">
                            <label>
                              Presentaciones:{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <select
                              name="empaque_id"
                              id="empaque_id"
                              onChange={(e) =>
                                this.props.component.handleChangeProductoRegistrado(e)
                              }
                              value={this.props.state.producto_registrado.presentacion}
                              className="form-control"
                              required
                            >
                              <option value="">Seleccione</option>
                              {this.props.state.presentaciones.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.empaque} ({option.cantidad}{" "}
                                  {option.unidad_medida})
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="form-group col-lg-2">
                          <label htmlFor="cantidad_precertificado_producto_registrado">
                            Cantidad: <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            value={
                              this.props.state.producto_registrado.cantidad
                            }
                            name="cantidad"
                            maxLength={7}
                            onChange={(e) =>
                              this.props.component.handleChangeProductoRegistrado(
                                e
                              )
                            }
                            className="form-control"
                            id="cantidad"
                            title="Cantidad"
                            placeholder=""
                            required
                          />
                        </div>

                        <div
                          className={
                            this.props.state.actividades.length > 1
                              ? "form-group col-lg-2.5"
                              : "hide"
                          }
                        >
                          <label htmlFor="establecimiento_precertificado">
                            Tipo de precertificado:
                            <span className="text-danger"> *</span>
                          </label>
                          <select
                            name="tipo_precertificado_id"
                            className="form-control m-b-5"
                            value={
                              this.props.state.producto_registrado
                                .tipo_precertificado_id
                            }
                            onChange={(e) =>
                              this.props.component.handleChangeProductoRegistrado(
                                e
                              )
                            }
                          >
                            <option value="" className="dropdown-item">
                              Seleccione...
                            </option>
                            {this.props.state.options_tipo_precertificado
                              .filter((e) => e.id !== "3")
                              .map((option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.descripcion}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div
                          className="col-md-1"
                          style={{ marginTop: "1.5em" }}
                        >
                          <button
                            type="button"
                            className="btn btn-info col-md-12"
                            onClick={this.props.component.addProductoRegistrado}
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <div
                        className={
                          this.props.state.lista_productos_registrados.length >
                          0
                            ? "row"
                            : "row hide"
                        }
                      >
                        <div className="col-md-12">
                          <table className="table table-striped m-b-0 table-hover">
                            <thead>
                              <tr>
                                <th>No. registro</th>
                                <th>Nombre comercial</th>
                                <th>Presentación</th>
                                <th>Unidad de medida</th>
                                <th>Pais origen</th>
                                <th>Cantidad</th>
                                <th
                                  className={
                                    this.props.state.actividades.length > 1
                                      ? ""
                                      : "hide"
                                  }
                                >
                                  Tipo precertificado
                                </th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.state.lista_productos_registrados
                                .length > 0
                                ? this.props.state.lista_productos_registrados.map(
                                    (reg, index) => (
                                      <tr key={index} id={"t" + index}>
                                        <td>{reg.no_registro}</td>
                                        <td>{reg.nombre_comercial}</td>
                                        <td>{reg.empaque_name}</td>
                                        <td>
                                          {reg.presentacion_cantidad} {reg.unidad_medida_name}
                                        </td>
                                        <td>{reg.pais_origen}</td>
                                        <td>{reg.cantidad}</td>
                                        <td
                                          className={
                                            reg.tipo_precertificado_id !== ""
                                              ? ""
                                              : "hide"
                                          }
                                        >
                                          {reg.tipo_precertificado_name}
                                        </td>
                                        <td>
                                          <button
                                            id={index}
                                            onClick={
                                              this.props.component
                                                .removeProductoRegistrado
                                            }
                                            className="btn btn-warning pull-right"
                                          >
                                            <i
                                              id={index}
                                              onClick={
                                                this.props.component
                                                  .removeProductoRegistrado
                                              }
                                              className="fas fa-trash"
                                            ></i>
                                          </button>
                                        </td>
                                      </tr>
                                    )
                                  )
                                : ""}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </fieldset>

                    {/* PRODUCTOS NO REGISTRADOS */}

                    <fieldset
                      className="col-md-12"
                      style={{ backgroundColor: "#6F6F6F" }}
                    >
                      <legend style={{ backgroundColor: "#6F6F6F" }}>
                        Productos NO registrados
                      </legend>

                      <div className="row">
                        <div className="form-group col-md-6">
                          <label>Razón social de fabricante</label>

                          <input
                            type="text"
                            name="razon_social"
                            id="razon_social_f"
                            onChange={
                              this.props.component.handleChangeFabricante
                            }
                            value={
                              this.props.state.producto_no_registrado
                                .establecimiento_razon_social
                            }
                            className="form-control"
                            disabled={this.props.state.disableFabricante}
                            placeholder="Ingrese razón social "
                            required
                          />
                        </div>

                        <div className="form-group col-md-5">
                          <label>GUID Fabricante</label>

                          <input
                            type="text"
                            name="guid"
                            id="guid_f"
                            onChange={
                              this.props.component.handleChangeFabricante
                            }
                            value={
                              this.props.state.producto_no_registrado
                                .establecimiento_guid
                            }
                            className="form-control"
                            maxLength="4"
                            placeholder="Ingrese GUID"
                            disabled={this.props.state.disableFabricante}
                            required
                          />
                        </div>

                        <div className="col-md-1">
                          <br />
                          <div
                            id="addEstFab"
                            onClick={this.props.component.handleGuidFabricante}
                            className=" btn btn-light"
                          >
                            <i className="fa fa-th"></i>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-md-6">
                          Nombre comercial:{" "}
                          <span className="text-danger">*</span>
                          <input
                            name="nombre_comercial"
                            type="input"
                            onChange={
                              this.props.component
                                .handleChangeProductoNORegistrado
                            }
                            value={
                              this.props.state.producto_no_registrado
                                .nombre_comercial
                            }
                            className="form-control m-b-5"
                            placeholder=""
                            //required
                          />
                        </div>

                        <div className="form-group col-md-3">
                          Cantidad total: <span className="text-danger">*</span>
                          <input
                            type="text"
                            value={
                              this.props.state.producto_no_registrado
                                .cantidad_total
                            }
                            name="cantidad_total"
                            maxLength={7}
                            onChange={(e) =>
                              this.props.component.handleChangeProductoNORegistrado(
                                e
                              )
                            }
                            className="form-control m-b-5"
                            placeholder=""
                            //required
                          />
                        </div>

                        <div className="form-group col-lg-3">
                          <label htmlFor="establecimiento_precertificado">
                            País: <span className="text-danger"> *</span>
                          </label>
                          <select
                            name="pais_id"
                            className="form-control m-b-5"
                            value={
                              this.props.state.producto_no_registrado.pais_id
                            }
                            onChange={(e) =>
                              this.props.component.handleChangeProductoNORegistrado(
                                e
                              )
                            }
                          >
                            <option value="" className="dropdown-item">
                              Seleccione...
                            </option>
                            {this.props.state.options_countries.map(
                              (option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.descripcion}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>

                      <div className="row">
                        <div
                          className={
                            this.props.state.actividades.length > 1
                              ? "form-group col-lg-12"
                              : "hide"
                          }
                        >
                          <label htmlFor="establecimiento_precertificado">
                            Tipo de precertificado:{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <select
                            name="tipo_precertificado_id"
                            className="form-control m-b-5"
                            value={
                              this.props.state.producto_no_registrado
                                .tipo_precertificado_id
                            }
                            onChange={(e) =>
                              this.props.component.handleChangeProductoNORegistrado(
                                e
                              )
                            }
                          >
                            <option value="" className="dropdown-item">
                              Seleccione...
                            </option>
                            {this.props.state.options_tipo_precertificado
                              .filter((e) => e.id !== "3")
                              .map((option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.descripcion}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      {/* TIPO DE ENVASE */}

                      <div className="row" id="envases">
                        <div className="form-group col-md-6">
                          Tipo de envase/empaque:{" "}
                          <span className="text-danger">*</span>
                          <div className="row" style={{ marginLeft: "0.09em" }}>
                            <select
                              onChange={this.props.component.handleEmpaque}
                              name="empaque_id"
                              className="form-control m-b-5 "
                              value={
                                this.props.state.producto_no_registrado
                                  .empaque_id
                              }
                              //disabled={this.state.esBaja}
                            >
                              <option value="" className="dropdown-item">
                                Seleccione...
                              </option>
                              {this.props.state.options_empaque.map(
                                (option) => (
                                  <option
                                    className="dropdown-item"
                                    key={option.id}
                                    value={option.id}
                                  >
                                    {option.descripcion}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>

                        <div className="form-group col-md-3">
                          Presentaciones cantidad:{" "}
                          <span className="text-danger">*</span>
                          <input
                            name="presentacion_cantidad"
                            type="input"
                            onChange={this.props.component.handleEmpaque}
                            value={
                              this.props.state.producto_no_registrado
                                .presentacion_cantidad
                            }
                            className="form-control m-b-5"
                            placeholder=""
                            //required
                          />
                        </div>

                        <div className="form-group col-md-3">
                          Unidad de medida:{" "}
                          <span className="text-danger">*</span>
                          <select
                            onChange={this.props.component.handleEmpaque}
                            name="presentacion_unidad_medida"
                            className="form-control m-b-5 "
                            value={
                              this.props.state.producto_no_registrado
                                .presentacion_unidad_medida
                            }
                          >
                            <option value="" className="dropdown-item">
                              Seleccione...
                            </option>
                            {this.props.state.options_unidad_medida.map(
                              (option) => (
                                <option
                                  className="dropdown-item"
                                  key={option.id}
                                  value={option.id}
                                >
                                  {option.descripcion}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>

                      <div className="row" style={{ marginTop: "1.5em" }}>
                        <button
                          type="button"
                          className="btn btn-info col-md-12"
                          onClick={this.props.component.addProductoNORegistrado}
                        >
                          +
                        </button>
                      </div>

                      <div
                        className={
                          this.props.state.lista_productos_no_registrados
                            .length > 0
                            ? "row"
                            : "row hide"
                        }
                      >
                        <div className="col-md-12">
                          <table className="table table-striped m-b-0 table-hover">
                            <thead>
                              <tr>
                                {/*  <th>No. registro</th> */}
                                <th>Nombre comercial</th>
                                <th>Cantidad total</th>
                                <th>Fabricante</th>
                                <th>Pais origen</th>
                                <th>Tipo de envase/empaque</th>
                                <th>Presentación cantidad</th>
                                <th>Unidad de medida</th>

                                <th
                                  className={
                                    this.props.state.actividades.length > 1
                                      ? ""
                                      : "hide"
                                  }
                                >
                                  Tipo precertificado
                                </th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.state.lista_productos_no_registrados
                                .length > 0
                                ? this.props.state.lista_productos_no_registrados.map(
                                    (reg, index) => (
                                      <tr key={index} id={"t" + index}>
                                        <td>{reg.nombre_comercial}</td>
                                        <td>{reg.cantidad_total}</td>
                                        <td>
                                          {reg.establecimiento_razon_social}
                                        </td>
                                        <td>{reg.pais_name}</td>
                                        <td>{reg.empaque_name}</td>
                                        <td>{reg.presentacion_cantidad}</td>
                                        <td>
                                          {reg.presentacion_unidad_medida_name}
                                        </td>
                                        <td
                                          className={
                                            reg.tipo_precertificado_id !== ""
                                              ? ""
                                              : "hide"
                                          }
                                        >
                                          {reg.tipo_precertificado_name}
                                        </td>
                                        <td>
                                          <button
                                            id={index}
                                            onClick={
                                              this.props.component
                                                .removeProductoNORegistrado
                                            }
                                            className="btn btn-warning pull-right"
                                          >
                                            <i
                                              id={index}
                                              onClick={
                                                this.props.component
                                                  .removeProductoNORegistrado
                                              }
                                              className="fas fa-trash"
                                            ></i>
                                          </button>
                                        </td>
                                      </tr>
                                    )
                                  )
                                : ""}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </fieldset>

                    {/* CADUCIDAD (input y select unidad medida) */}

                    <div className="row">
                      <div className="form-group col-lg-6">
                        <label htmlFor="nombre_producto">
                          Nombre del consignatario:{" "}
                          <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="input"
                          className="form-control"
                          name="nombre_comercial"
                          //placeholder="Causa de la sanción"
                          value={this.props.state.nombre_consignatario}
                          onChange={this.props.component.handleConsignatario}
                        />
                      </div>

                      <div className="form-group col-md-6">
                        País destino: <span className="text-danger">*</span>
                        <select
                          name="pais_destino_id"
                          className="form-control m-b-5 "
                          value={this.props.state.pais_id}
                          onChange={this.props.component.handleChangePais}
                        >
                          <option value="" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.props.state.options_countries.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  {this.props.state.registros_docs !== 0 &&
                  this.props.state.show_info_precertificado ? (
                    <>
                      <hr></hr>
                      <fieldset style={{ backgroundColor: "#6F6F6F" }}>
                        <legend style={{ backgroundColor: "#6F6F6F" }}>
                          Documentación
                        </legend>
                        <div className="row">
                          <div className="form-group col-md-10">
                            <label>
                              <span className="text-danger">
                                {" "}
                                Solo se aceptan archivos ".pdf"*
                              </span>
                            </label>
                            <select
                              name="tipo_documento"
                              id="tipo_documento"
                              onChange={(e) =>
                                this.props.component.handleChangeTipoDocumento(
                                  e
                                )
                              }
                              value={this.props.state.tipo_documento_id}
                              className="form-control"
                            >
                              <option value="">
                                Seleccione el documento...
                              </option>
                              {this.props.state.tipo_documentos.map(
                                (option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.descripcion}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          <div
                            className="col-md-2"
                            style={{ marginTop: "1.7%" }}
                          >
                            <button
                              type="button"
                              name="b_documento"
                              className="btn btn-primary"
                              onClick={(e) => {
                                if (this.props.state.tipo_documento_id === "") {
                                  Swal.fire({
                                    title: "Atención",
                                    text: "Seleccione tipo de documento a cargar.",
                                  });
                                  return;
                                } else {
                                  hiddenFileInput.current.click();
                                }
                              }}
                            >
                              Seleccionar archivo
                            </button>
                            <input
                              type="file"
                              accept=".pdf"
                              ref={hiddenFileInput}
                              name="documento"
                              onChange={(e) =>
                                this.props.component.handleFile(e.target)
                              }
                              onClick={(e) => {
                                //this.props.component.validarseleccion(event);
                                e.target.value = null;
                              }}
                              style={{ display: "none" }}
                            />
                          </div>
                        </div>
                        <hr></hr>
                        <div className="table-responsive">
                          <table className="table table-striped m-b-0 table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">Tipo documento</th>
                                <th className="text-center">
                                  Nombre documento
                                </th>
                                <th className="text-center">Vista previa</th>
                                <th className="text-center"> </th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.props.state.documentos.length > 0 ? (
                                this.props.state.documentos.map(
                                  (doc, index) => (
                                    <tr key={index} id={index}>
                                      <td className="text-center">
                                        {doc.tipo_documento}
                                      </td>
                                      <td className="text-center">
                                        {doc.nombre}
                                      </td>
                                      <td className="text-center">
                                        <div
                                          onClick={(e) =>
                                            this.props.component.handleVistaPrevia(
                                              e
                                            )
                                          }
                                          data-file={doc.pdf}
                                          name="pdf"
                                          className="btn btn-danger"
                                          id={index}
                                          width="60"
                                          title="Vista previa"
                                        >
                                          <i
                                            className="fa fa-file-pdf"
                                            name="pdf"
                                            id={index}
                                          ></i>
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        <div
                                          className="btn btn-warning remover-documento"
                                          id={index}
                                          title="Remover"
                                          data-tipo_documento_id={
                                            doc.tipo_documento_id
                                          }
                                          data-descripcion={doc.tipo_documento}
                                          onClick={
                                            this.props.component.removeDocument
                                          }
                                        >
                                          <i
                                            className="fas fa-trash"
                                            id={index}
                                            title="Remover"
                                            data-tipo_documento_id={
                                              doc.tipo_documento_id
                                            }
                                            data-descripcion={
                                              doc.tipo_documento
                                            }
                                            onClick={
                                              this.props.component
                                                .removeDocument
                                            }
                                          ></i>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td className="text-center"></td>
                                  <td className="text-center">
                                    No hay documentos
                                  </td>
                                  <td className="text-left"></td>
                                  <td className="text-center"></td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </fieldset>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </fieldset>
          <div className={this.props.state.previa ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              src={`data:application/pdf;base64,${this.props.state.previa_url}`}
              width="100%"
              height="100%"
              name="iframe"
            ></iframe>
            <center>
              <div className="btn-group">
                <div
                  onClick={(e) => {
                    this.props.component.handleCloseVistaPrevia(e);
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </div>
              </div>
            </center>
          </div>
          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModalPrecertificado(1);
                //this.props.component.limpiarCampos(1);
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="button"
              onClick={() => {
                this.props.component.handleSubmit();
              }}
              className="btn btn-success"
            >
              Generar precertificado
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ModalPrecertificado;
